/**
 * Receipt totals from booking legs (mirrors backend bookingReceiptTotalsHelper).
 */

import { getBookingLegs } from './bookingLegStatus';

function parseAmount(value) {
  const parsed = parseFloat(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
}

function round2(value) {
  return Math.round(value * 100) / 100;
}

function getLegCashPaid(leg) {
  const changeFee = parseAmount(leg.flight_change_fee_paid);
  const changeFare = parseAmount(leg.change_fare_paid);
  const paid = parseAmount(leg.paid_total_amount);

  if (leg.parent_booking_id) {
    return round2(changeFee + changeFare);
  }

  return round2(paid + changeFee + changeFare);
}

function getLegPreDiscountSubtotal(leg) {
  const paid = parseAmount(leg.paid_total_amount);
  const promoDiscount = parseAmount(leg.promo_discount_amount);

  if (leg.parent_booking_id) {
    return round2(parseAmount(leg.change_fare_paid) + parseAmount(leg.flight_change_fee_paid));
  }

  if (promoDiscount > 0 && paid > 0) {
    return round2(paid + promoDiscount);
  }

  return paid > 0 ? paid : 0;
}

export function buildReceiptTotalsFromBooking(booking) {
  const legs = getBookingLegs(booking);
  const passengerCount = Math.max(1, parseInt(String(booking?.passenger_count ?? 1), 10) || 1);

  let promoDiscountTotal = 0;
  let flightChangeFeeTotal = 0;
  let changeFareTotal = 0;
  let subtotalBeforeDiscount = 0;
  let totalPaid = 0;
  let promoCode = null;

  for (const leg of legs) {
    totalPaid += getLegCashPaid(leg);
    flightChangeFeeTotal += parseAmount(leg.flight_change_fee_paid);
    changeFareTotal += parseAmount(leg.change_fare_paid);
    promoDiscountTotal += parseAmount(leg.promo_discount_amount);
    if (leg.promo_code?.trim()) {
      promoCode = leg.promo_code.trim();
    }
    subtotalBeforeDiscount += getLegPreDiscountSubtotal(leg);
  }

  totalPaid = round2(totalPaid);
  subtotalBeforeDiscount = round2(subtotalBeforeDiscount);
  if (subtotalBeforeDiscount < totalPaid) {
    subtotalBeforeDiscount = totalPaid;
  }

  return {
    currency: booking?.paid_currency || 'USD',
    passengerCount,
    subtotalBeforeDiscount,
    promoCode,
    promoDiscountTotal: round2(promoDiscountTotal),
    flightChangeFeeTotal: round2(flightChangeFeeTotal),
    changeFareTotal: round2(changeFareTotal),
    totalPaid,
    farePerPax: round2(subtotalBeforeDiscount / passengerCount),
    farePerPaxPaid: round2(totalPaid / passengerCount),
  };
}
